<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Approved Applications</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  <i class="bx bx-check-shield me-2 text-success"></i>Approved Applications
                </h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">E-Construction</a></li>
                    <li class="breadcrumb-item active">Approved Applications</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Stats Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid border-start border-success border-3">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Approved</p>
                      <h4 class="mb-0">{{ total }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-success align-self-center">
                        <span class="avatar-title">
                          <i class="bx bx-check-shield font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Ready for Permit</p>
                      <h4 class="mb-0 text-success">{{ readyForPermitCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-soft-success align-self-center">
                        <span class="avatar-title bg-success">
                          <i class="bx bx-printer font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Partial Payment</p>
                      <h4 class="mb-0 text-warning">{{ partialPaymentCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-warning align-self-center">
                        <span class="avatar-title">
                          <i class="bx bx-time font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Awaiting Payment</p>
                      <h4 class="mb-0 text-danger">{{ awaitingPaymentCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-danger align-self-center">
                        <span class="avatar-title">
                          <i class="bx bx-wallet font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-soft-success">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <h5 class="card-title mb-0 text-success">
                        <i class="bx bx-list-check me-2"></i>Approved Applications List
                      </h5>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <!-- Search Box -->
                        <div class="search-box">
                          <div class="position-relative">
                            <input
                                v-model="search"
                                type="text"
                                class="form-control"
                                placeholder="Search by project, bill no, plot..."
                                style="min-width: 280px;"
                            >
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                        <!-- Refresh Button -->
                        <button
                            class="btn btn-soft-success"
                            @click="getApplications(currentPage)"
                            :disabled="loading"
                        >
                          <i class="bx bx-refresh" :class="{ 'bx-spin': loading }"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading approved applications...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="applications.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <div class="avatar-title bg-soft-success text-success rounded-circle">
                        <i class="bx bx-folder-open font-size-24"></i>
                      </div>
                    </div>
                    <h5>No Approved Applications Found</h5>
                    <p class="text-muted">There are no approved applications matching your search criteria.</p>
                  </div>

                  <!-- Applications Table -->
                  <div v-else class="table-responsive">
                    <table class="table table-hover table-centered mb-0">
                      <thead class="table-light">
                      <tr>
                        <th style="width: 50px">#</th>
                        <th>Application Details</th>
                        <th>Location</th>
                        <th>Final Payment Status</th>
                        <th class="text-end">Final Amount (KES)</th>
                        <th style="width: 220px" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(application, index) in applications" :key="application.id">
                        <td>
                          <span class="text-muted">{{ ((currentPage - 1) * rowsPerPage) + index + 1 }}</span>
                        </td>
                        <td>
                          <div class="d-flex flex-column">
                            <div class="d-flex align-items-center mb-1">
                                  <span class="badge bg-soft-success text-success me-2">
                                    <i class="bx bx-check me-1"></i>Approved
                                  </span>
                              <span class="fw-semibold text-primary">
                                    {{ application.billNoFinal }}
                                  </span>
                            </div>
                            <span class="fw-medium text-truncate" style="max-width: 200px;" :title="application.project_title">
                                  {{ application.project_title }}
                                </span>
                            <small class="text-muted">
                              <i class="bx bx-calendar me-1"></i>{{ formatDate(application.created_at) }}
                              <span class="mx-2">|</span>
                              <i class="bx bx-building me-1"></i>{{ capitalizeFirstLetter(application.development_type) }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fw-medium">{{ application.subCountyName }}</span>
                            <small class="text-muted">{{ application.wardName }}</small>
                            <small class="text-muted">
                              <i class="bx bx-map-pin me-1"></i>Plot: {{ application.plot_number }}
                            </small>
                          </div>
                        </td>
                        <td>
                              <span :class="getPaymentStatusBadge(application.finalPayment)">
                                <i :class="getPaymentStatusIcon(application.finalPayment)" class="me-1"></i>
                                {{ application.finalPayment }}
                              </span>
                          <div class="mt-1">
                            <small class="text-muted">
                              Paid: <span class="text-success fw-medium">{{ formatCurrency(application.receiptAmountFinal) }}</span>
                            </small>
                          </div>
                          <div v-if="application.finalPayment === 'PAID'" class="mt-1">
                            <small class="text-success">
                              <i class="bx bx-check-circle me-1"></i>Ready for permit
                            </small>
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <span class="fw-bold text-dark">{{ formatCurrency(application.detailAmountFinal) }}</span>
                            <small :class="parseFloat(application.billBalanceFinal) > 0 ? 'text-danger' : 'text-success'">
                              Balance: {{ formatCurrency(application.billBalanceFinal) }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center gap-1">
                            <button
                                class="btn btn-soft-info btn-sm"
                                @click="viewDetails(application.id)"
                                title="View Details"
                            >
                              <i class="bx bx-show"></i>
                            </button>
                            <button
                                class="btn btn-soft-primary btn-sm"
                                @click="printApplicationAcknowledgment(application)"
                                title="Print Acknowledgment"
                            >
                              <i class="bx bx-file"></i>
                            </button>
                            <button
                                class="btn btn-sm"
                                :class="application.finalPayment === 'PAID' ? 'btn-success' : 'btn-soft-secondary'"
                                :disabled="application.finalPayment !== 'PAID'"
                                @click="printConstructionPermit(application.id, application.finalPayment)"
                                :title="application.finalPayment === 'PAID' ? 'Print Permit' : 'Final payment required'"
                            >
                              <i class="bx bx-id-card"></i>
                            </button>
                            <div class="dropdown">
                              <button
                                  class="btn btn-soft-secondary btn-sm dropdown-toggle"
                                  type="button"
                                  :id="'dropdownActions' + application.id"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                              >
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-end" :aria-labelledby="'dropdownActions' + application.id">
                                <li>
                                  <a class="dropdown-item" href="javascript: void(0);" @click.prevent="viewDetails(application.id)">
                                    <i class="bx bx-show me-2 text-info"></i>View Details
                                  </a>
                                </li>
                                <li>
                                  <a class="dropdown-item" href="javascript: void(0);" @click.prevent="printApplicationAcknowledgment(application)">
                                    <i class="bx bx-file me-2 text-primary"></i>Print Acknowledgment
                                  </a>
                                </li>
                                <li>
                                  <a
                                      class="dropdown-item"
                                      :class="{ 'disabled text-muted': application.finalPayment !== 'PAID' }"
                                      href="javascript: void(0);"
                                      @click.prevent="printConstructionPermit(application.id, application.finalPayment)"
                                  >
                                    <i class="bx bx-id-card me-2" :class="application.finalPayment === 'PAID' ? 'text-success' : ''"></i>
                                    Print Permit
                                    <small v-if="application.finalPayment !== 'PAID'" class="d-block text-danger ms-4">
                                      (Payment required)
                                    </small>
                                  </a>
                                </li>
                                <li><hr class="dropdown-divider"></li>
                                <li>
                                  <a class="dropdown-item" href="javascript: void(0);" @click.prevent="downloadInvoice(application)">
                                    <i class="bx bx-receipt me-2 text-warning"></i>Download Invoice
                                  </a>
                                </li>
                                <li v-if="application.finalPayment === 'PAID' || application.finalPayment === 'PARTIAL'">
                                  <a class="dropdown-item" href="javascript: void(0);" @click.prevent="downloadReceipt(application)">
                                    <i class="bx bx-download me-2 text-success"></i>Download Receipt
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="applications.length > 0" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="d-flex align-items-center">
                        <span class="text-muted me-2">Show</span>
                        <select
                            v-model="rowsPerPage"
                            class="form-select form-select-sm"
                            style="width: 70px;"
                            @change="getApplications(1)"
                        >
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        <span class="text-muted ms-2">
                            entries | Showing {{ ((currentPage - 1) * rowsPerPage) + 1 }} to {{ Math.min(currentPage * rowsPerPage, total) }} of {{ total }}
                          </span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <nav aria-label="Page navigation" class="float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="javascript: void(0);" @click.prevent="changePage(1)">
                              <i class="bx bx-chevrons-left"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="javascript: void(0);" @click.prevent="changePage(currentPage - 1)">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li
                              v-for="page in getPaginationRange()"
                              :key="page"
                              class="page-item"
                              :class="{ active: currentPage === page }"
                          >
                            <a class="page-link" href="javascript: void(0);" @click.prevent="changePage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="javascript: void(0);" @click.prevent="changePage(currentPage + 1)">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="javascript: void(0);" @click.prevent="changePage(totalPages)">
                              <i class="bx bx-chevrons-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Application Details Modal Component -->
      <ApplicationDetailsModal
          v-if="selectedApplicationId"
          :application-id="selectedApplicationId"
          :can-approve="false"
          :can-decline="false"
          @download-invoice="downloadInvoice"
          @download-receipt="downloadReceipt"
      />

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ApplicationDetailsModal from "@/components/econstruct/inprogress/ApplicationDetailsModal.vue";
import { biller, econstruction, execute } from "@/api";

export default {
  name: "eConstructionApproved",
  components: {
    NavigationBar,
    ApplicationDetailsModal
  },
  data() {
    return {
      search: "",
      applications: [],
      loading: true,
      total: 0,
      currentPage: 1,
      rowsPerPage: 10,
      selectedApplicationId: null,
      searchTimer: null,
      // Stats
      readyForPermitCount: 0,
      partialPaymentCount: 0,
      awaitingPaymentCount: 0
    };
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.loading = true;
      this.searchTimer = setTimeout(() => {
        this.getApplications(1);
      }, 500);
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.rowsPerPage);
    }
  },
  mounted() {
    this.getApplications();
  },
  methods: {
    getApplications(page = 1) {
      this.loading = true;
      this.currentPage = page;

      const data = new FormData();
      data.append("function", "getApplications");
      data.append("page", page);
      data.append("rows_per_page", this.rowsPerPage);
      data.append("search", this.search);
      data.append("status", "approved");

      execute(data, econstruction)
          .then((res) => {
            if (res.data.success && res.data.data) {
              this.applications = res.data.data.applications;
              this.total = parseInt(res.data.data.total);
              this.rowsPerPage = parseInt(res.data.data.rows_per_page);

              // Calculate stats
              this.calculateStats();
            } else {
              console.error("Failed to load applications");
              if (this.$toast) {
                this.$toast.error("Failed to load applications");
              }
            }
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error loading applications:", e);
            if (this.$toast) {
              this.$toast.error("Error loading applications: " + (e.message || "Unknown error"));
            }
          });
    },

    calculateStats() {
      this.readyForPermitCount = this.applications.filter(a => a.finalPayment?.toUpperCase() === 'PAID').length;
      this.partialPaymentCount = this.applications.filter(a => a.finalPayment?.toUpperCase() === 'PARTIAL').length;
      this.awaitingPaymentCount = this.applications.filter(a => a.finalPayment?.toUpperCase() === 'UNPAID').length;
    },

    getPaginationRange() {
      const maxVisiblePages = 5;
      let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      const pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.getApplications(page);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },

    formatCurrency(amount) {
      if (!amount && amount !== 0) return '0.00';
      return parseFloat(amount).toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getPaymentStatusBadge(status) {
      if (!status) return 'badge bg-secondary';
      switch(status.toUpperCase()) {
        case 'PAID':
          return 'badge bg-soft-success text-success';
        case 'PARTIAL':
          return 'badge bg-soft-warning text-warning';
        case 'UNPAID':
          return 'badge bg-soft-danger text-danger';
        default:
          return 'badge bg-soft-secondary text-secondary';
      }
    },

    getPaymentStatusIcon(status) {
      if (!status) return 'bx bx-question-mark';
      switch(status.toUpperCase()) {
        case 'PAID':
          return 'bx bx-check-circle';
        case 'PARTIAL':
          return 'bx bx-time-five';
        case 'UNPAID':
          return 'bx bx-x-circle';
        default:
          return 'bx bx-question-mark';
      }
    },

    // Print Application Acknowledgment
    printApplicationAcknowledgment(application) {
      const printData = {
        applicationNumber: application.billNoFinal || application.billNo,
        projectTitle: application.project_title,
        developmentType: application.development_type,
        subCounty: application.subCountyName,
        ward: application.wardName,
        plotNumber: application.plot_number,
        applicationDate: application.created_at,
        billAmount: application.detailAmountFinal,
        paidAmount: application.receiptAmountFinal,
        balance: application.billBalanceFinal,
        paymentStatus: application.finalPayment,
        status: 'Approved',
        applicantName: application.applicant_name || application.applicantName || '',
        applicantPhone: application.applicant_phone || application.phone || '',
        applicantEmail: application.applicant_email || application.email || '',
        applicantIdNumber: application.id_number || application.idNumber || ''
      };

      localStorage.setItem('applicationReceiptData', JSON.stringify(printData));
      const routeData = this.$router.resolve({ name: 'application-receipt' });
      window.open(routeData.href, '_blank');
    },

    viewDetails(applicationId) {
      this.selectedApplicationId = applicationId;

      const checkAndOpenModal = () => {
        const modalId = `details-${applicationId}`;
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
          if (window.$) {
            window.$(`#${modalId}`).modal('show');
          } else {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');
            const backdrop = document.createElement('div');
            backdrop.classList.add('modal-backdrop', 'fade', 'show');
            document.body.appendChild(backdrop);
          }
          return true;
        }
        return false;
      };

      setTimeout(() => {
        if (!checkAndOpenModal()) {
          setTimeout(() => {
            if (!checkAndOpenModal()) {
              setTimeout(checkAndOpenModal, 500);
            }
          }, 300);
        }
      }, 100);
    },

    downloadInvoice(application) {
      const data = new FormData();
      data.append("function", "downloadInvoice");
      data.append("billNo", application.billNoFinal || application.billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.pdfUrl) {
              window.open(res.data.data.pdfUrl, '_blank');
            } else {
              if (this.$toast) {
                this.$toast.error("Failed to download invoice: " + (res.data.message || "Unknown error"));
              }
            }
          })
          .catch((e) => {
            if (this.$toast) {
              this.$toast.error("Error downloading invoice: " + (e.message || "Unknown error"));
            }
          });
    },

    downloadReceipt(application) {
      const data = new FormData();
      data.append("function", "downloadReceipt");
      data.append("billNo", application.billNoFinal || application.billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.pdfUrl) {
              window.open(res.data.data.pdfUrl, '_blank');
            } else {
              if (this.$toast) {
                this.$toast.error("Failed to download receipt: " + (res.data.message || "Unknown error"));
              }
            }
          })
          .catch((e) => {
            if (this.$toast) {
              this.$toast.error("Error downloading receipt: " + (e.message || "Unknown error"));
            }
          });
    },

    printConstructionPermit(applicationId, finalPayment) {
      if (finalPayment !== 'PAID') {
        if (this.$toast) {
          this.$toast.warning("Final payment must be completed before printing the permit");
        } else {
          alert("The Final Payment has not been paid for");
        }
        return;
      }

      const data = new FormData();
      data.append("function", "printConstructionPermit");
      data.append("applicationId", applicationId);

      execute(data, econstruction)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({
                applicationId: applicationId
              });
              const routeData = this.$router.resolve({ name: 'construction-permits' });
              window.open(routeData.href, '_blank');
            } else {
              if (this.$toast) {
                this.$toast.error(res.data.message || "Failed to print permit");
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((e) => {
            if (this.$toast) {
              this.$toast.error("Error: " + (e.message || "Unknown error"));
            } else {
              alert(e.message);
            }
          });
    }
  }
};
</script>

<style scoped>
.mini-stats-wid {
  transition: transform 0.2s ease-in-out;
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.table-hover tbody tr:hover {
  background-color: rgba(52, 195, 143, 0.05);
}

.btn-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
  color: #34c38f;
  border: none;
}

.btn-soft-success:hover {
  background-color: #34c38f;
  color: #fff;
}

.btn-soft-primary {
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  border: none;
}

.btn-soft-primary:hover {
  background-color: var(--bs-primary);
  color: #fff;
}

.btn-soft-info {
  background-color: rgba(var(--bs-info-rgb), 0.1);
  color: var(--bs-info);
  border: none;
}

.btn-soft-info:hover {
  background-color: var(--bs-info);
  color: #fff;
}

.btn-soft-secondary {
  background-color: rgba(var(--bs-secondary-rgb), 0.1);
  color: var(--bs-secondary);
  border: none;
}

.btn-soft-secondary:hover {
  background-color: var(--bs-secondary);
  color: #fff;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.15) !important;
}

.bg-soft-warning {
  background-color: rgba(var(--bs-warning-rgb), 0.15) !important;
}

.bg-soft-danger {
  background-color: rgba(var(--bs-danger-rgb), 0.15) !important;
}

.bg-soft-secondary {
  background-color: rgba(var(--bs-secondary-rgb), 0.15) !important;
}

.search-box .form-control {
  padding-left: 40px;
  border-radius: 20px;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.pagination-rounded .page-link {
  border-radius: 50% !important;
  margin: 0 3px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.dropdown-menu {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  border: none;
}

.dropdown-item {
  padding: 0.5rem 1rem;
}

.dropdown-item:hover {
  background-color: rgba(52, 195, 143, 0.1);
}

.dropdown-item.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.border-start.border-success {
  border-left-width: 3px !important;
}

.card-header.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1) !important;
  border-bottom: 1px solid rgba(52, 195, 143, 0.2);
}
</style>